module.exports = __webpack_public_path__ + "media/site/images/coffeetime/coffeetime-coffee@2x-4b680a52eb49fddf0fa4c212edc5ac0b.png";